import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { request } from "@app/services";
import {
  addModel,
  addModelFailed,
  addModelSuccess,
  model,
  modelFailed,
  modelSuccess,
  deleteModel,
  deleteModelFailed,
  deleteModelSuccess,
  updateModel,
  updateModelSuccess,
  updateModelFailed,
} from "./slice";
import * as endpoints from "./endpoints";
import { selectModelState } from "./selector";
import { IModelData } from "./types";

//--------------------GetAllModels-------------------------
function* modelSaga(action: ReturnType<typeof model>): any {
  try {
    const response = yield call(request.get, endpoints.models);
    if (response?.status) {
      yield put(modelSuccess(response.data));
    }
  } catch (error: any) {
    yield put(modelFailed(error));
  }
}

//--------------------AddModelSaga-------------------------
export function* addModelSaga(action: ReturnType<typeof addModel>): any {
  try {
    const modelState = yield select(selectModelState);
    const formData = action.payload;

    const response = yield call(request.post, endpoints.addModels, formData);

    yield put(addModelSuccess(response?.data));
  } catch (error: any) {
    console.error("Saga Error Details:", error);
    console.error("Error Response:", error.response?.data);
    yield put(addModelFailed(error));
  }
}
//--------------------UpdateModelSaga-------------------------
export function* updateModelSaga(action: ReturnType<typeof updateModel>): any {
  try {
    const modelState = yield select(selectModelState);
    const formData = action.payload;

    if (formData.get("selectedModelId")) {
      const selectedModelId = formData.get("selectedModelId");

      const response = yield call(
        request.patch,
        `${endpoints.updateModelById}${selectedModelId}`,
        formData
      );

      yield put(updateModelSuccess(response?.data));

      if (Array.isArray(modelState.data) && modelState.data.length > 0) {
        const updatedModels = modelState.data.map((item: IModelData) => {
          if (item.id == selectedModelId) {
            return {
              ...item,
              ...response?.data,
            };
          }
          return item;
        });
        // yield put(modelSuccess(updatedModels));
      }
    }
  } catch (error: any) {
    console.error("Saga Error Details:", error);
    console.error("Error Response:", error.response?.data);
    yield put(updateModelFailed(error));
  }
}

//--------------------DeleteModelSaga-------------------------
function* deleteModelSaga(action: ReturnType<typeof deleteModel>): any {
  try {
    const { modelId } = action.payload;
    const modelState = yield select(selectModelState);

    const response = yield call(
      request.delete,
      `${endpoints.deleteModelById}${modelId}`
    );

    yield put(deleteModelSuccess(response?.message));

    if (Array.isArray(modelState?.data) && modelState?.data?.length > 0) {
      const newModels = modelState.data.filter(
        (item: { id: number }) => item.id !== modelId
      );
      yield put(modelSuccess(newModels));
    }
  } catch (err: any) {
    yield put(deleteModelFailed(err));
  }
}

function* modelSagas() {
  yield all([
    takeLatest(model, modelSaga),
    takeLatest(addModel, addModelSaga),
    takeLatest(deleteModel, deleteModelSaga),
    takeLatest(updateModel, updateModelSaga),
  ]);
}

export { modelSagas };
